var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Rectangle.cb1a584d.png","uri@2x": __webpack_public_path__ + "static/media/Rectangle.46d5c3f8.png","uri@3x": __webpack_public_path__ + "static/media/Rectangle.5bd193b5.png",
    width: 320,
    height: 24
});